import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next';
import customerActions from '../../Actions/customerActions'
import helpers from '../../Utils/helpers';
import commonActions from '../../Actions/commonActions'
import { useNavigate  } from 'react-router-dom'
import {NoInformation} from "../../Components/Panel";
import useModal from "../../Hooks/useModal"
import Modals from "../../Constants/modals";
import AttendedOnboardingDetails from "../../Components/Customer/AttendedOnboardingDetails";

const AttendedOnboardingsContainer = ({ customerActions, customer, attendedOnboardings, t}) => {
    const { openModal, isModalOpen } = useModal();

    useEffect(() => {
        customerActions.getCustomerAttendedOnboardings(customer.vbCustomer.customerNumber);
    }, [])

    const onOnboardingClick = (onboarding) => {
        customerActions.getOnboardingFromId(onboarding.id);
        openModal(Modals.AttendedOnboardingsModal);
    }

    if (!attendedOnboardings || attendedOnboardings.length === 0) 
        return <NoInformation/>

    return <>
        <div className="table-responsive">
            <table className="table table-stripe">
                <thead>
                    <tr>
                        <th className="text-left">{t('attendedonboardingslist.contactperson')}</th>
                        <th className="text-left">{t('attendedonboardingslist.service')}</th>
                        <th className="text-left">{t('attendedonboardingslist.date')}</th>
                        <th className="text-left">{t('attendedonboardingslist.evaluationsent')}</th>
                    </tr>
                </thead>
                <tbody>
                    {attendedOnboardings.map((onboarding, index) => {
                        return <tr className="cursorpointer" key={index} onClick={() => onOnboardingClick(onboarding)}>
                            <td>{onboarding.contactPerson}</td>
                            <td>{onboarding.serviceName}</td>
                            <td>{helpers.formatDate(onboarding.fromDate)}</td>
                            <td>{onboarding.evaluationSent ? helpers.formatDate(onboarding.evaluationSent) : ""}</td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
        {isModalOpen(Modals.AttendedOnboardingsModal) && <AttendedOnboardingDetails />}
    </>
}

function mapStateToProps(state) {
    return {
        attendedOnboardings: state.CustomerReducer.attendedOnboardings,
        customer: state.CustomerReducer.customer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        customerActions: bindActionCreators(customerActions, dispatch),
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AttendedOnboardingsContainer));

